/* eslint-disable no-unused-expressions */
import React from 'react';
import PropTypes from 'prop-types';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import {
  Loader, Container, Icon, Switch, Badge, Select,
} from '../../ui-kit';
import { ButtonsGroup } from '../../components';
import { timeDateMonthString, monthName } from '../../services/datetime';
import './styles.scss';

const UserView = (props) => (
  <>
    <ButtonsGroup
      loading={props.users.loading || props.updateDataLoading}
      activeTabIndex={props.activeTab}
      badges={[
        {
          name: 'Applicants',
          separator: true,
        },
        {
          name: 'Representatives',
        },
        {
          name: 'Freelancers',
        },
        {
          name: 'Recruiters',
        },
      ]}
      setActiveTab={(index, tabName) => {
        props.setActiveTab(index);
        props.history.push(`#${tabName}`);
      }}
      refreshAction={() => props.refreshAction()}
    />
    <div className="users_sort_container">
      <Badge
        value="Sort by registration date"
        onClick={() => props.sortUsersListByDateOfCreation(props.renderDataObjectName(), props.directionRenderStr(), props.category)}
        rightArrow={(
          <div className="badge_short_arrow">
            <Icon name={`arrow-${props.directionStr === 'desc' || !props.directionStr
              ? 'up'
              : 'down'}-short`}
            />
          </div>
        )}
        disabled={props.users.loading || props.updateDataLoading}
      />
      <Select 
        options={[
          { key: 0, label: 'All users', value: '' }, 
          { key: 1, label: 'Modeling business', value: 'Modeling business' },
          { key: 2, label: 'Music', value: 'Music' },
          { key: 3, label: 'Hospitality', value: 'Hospitality' }, 
          { key: 4, label: 'Service', value: 'Service' },
          { key: 5, label: 'Entertainment', value: 'Entertainment' },
        ]}
        value={props.category}
        setValue={props.setCategory}
        onChange={(newValue) => props.sortUsersListByDateOfCreation(props.renderDataObjectName(), props.directionStr, newValue)}
        disabled={props.users.loading || props.updateDataLoading}
        className={props.activeTab !== 0 ? 'hidden' : ''}
      />
    </div>
    {props.users.loading ? (
      <div className="users_page_loader__block">
        <Loader type="big-loader" />
      </div>
    ) : (
      <div
        className={`${
          props.users.success && props.users.roles[props.renderDataObjectName()].data?.length
            ? "users_page__container "
            : "users_page__container_empty "
        }${props.updateDataLoading ? "users_page_blured" : ""}`}
      >
        {props.users.success && props.users.roles[props.renderDataObjectName()].data?.length ? (
          <Container className="users_table">
            <TableContainer>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell className="table_cell_header">Full name</TableCell>
                    {props.renderDataObjectName() === 'applicants' && (
                    <TableCell className="table_cell_header" align="right">
                      Subscribtion
                    </TableCell>
                    )}
                    <TableCell className="table_cell_header" align="right">
                      Created time
                    </TableCell>
                    <TableCell className="table_cell_header" align="right">
                      UID
                    </TableCell>
                    <TableCell className="table_cell_header" align="right">
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="row_container">
                  {props.users.roles[props.renderDataObjectName()].data?.map(
                    (row) => (
                      <TableRow
                        key={row.uid}
                        className="user_info_row"
                      >
                        <TableCell component="th" scope="row" onClick={() => props.history.push(`user#${row.uid}`)}>
                          <div className="avatar_and_full_name__container">
                            <div className="users_avatar__container">
                              <div
                                className={!row.avatar ? 'no_avatar__container' : 'avatar__container'}
                                style={row.avatar && {
                                  backgroundImage: `url(${row.avatar.uri})`,
                                  backgroundPosition: 'center',
                                  backgroundSize: 'cover',
                                  backgroundRepeat: 'no-repeat',
                                  borderRadius: '50%',
                                  height: '100%',
                                }}
                              >
                                {!row.avatar && (
                                  <Icon name="camera" />
                                )}
                              </div>
                            </div>
                            <span>
                              {row.name}
                              {' '}
                              {row.lastname}
                            </span>
                          </div>
                        </TableCell>
                        {row.role === 'applicant' && (
                          <TableCell align="right" className="users_payed_cell__container">
                            <div className="users_payed_cell">
                              <Switch
                                disabled={row.subscribe && row.subscribe.type === 'purchase' && row.subscribe.status}
                                isOn={row.subscribe && row.subscribe.status}
                                onChange={() => props.giveOutFullVersion(row.uid, row.role)}
                              />
                            </div>
                          </TableCell>
                        )}
                        <TableCell
                          align="right"
                          onClick={() => props.history.push(`user#${row.uid}`)}
                        >
                          {timeDateMonthString(
                            new Date(row._createdTime),
                            (dateArgument, date, hours, minutes) => `${date} ${monthName(
                              dateArgument,
                            ).slice(0, 3)}, ${hours}:${minutes}`,
                          )}
                        </TableCell>
                        <TableCell
                          align="right"
                          onClick={() => props.history.push(`user#${row.uid}`)}
                        >
                          {row.uid}
                        </TableCell>
                        <TableCell
                          align="right"
                          onClick={() => props.deleteUser(row.uid)}
                        >
                          Delete
                        </TableCell>
                      </TableRow>
                    ),
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Container>
        ) : (
          <div className="castings_empty__container">
            <div className="castings_empty">
              <Icon name="calendar-checked" />
              <p>There are no users yet</p>
            </div>
          </div>
        )}
      </div>
    )}
  </>
);

UserView.propTypes = {
  users: PropTypes.object,
  loading: PropTypes.bool,
  activeTab: PropTypes.number,
  setActiveTab: PropTypes.func,
  refreshAction: PropTypes.func,
  giveOutFullVersion: PropTypes.func,
  history: PropTypes.object,
  renderDataObjectName: PropTypes.object,
  updateDataLoading: PropTypes.bool,
  sortUsersListByDateOfCreation: PropTypes.func,
  directionRenderStr: PropTypes.func,
  directionStr: PropTypes.string,
  deleteUser: PropTypes.func,
};
UserView.defaultProps = {
  history: {},
  setActiveTab: () => {},
  users: {},
  loading: false,
  activeTab: 1,
  refreshAction: () => {},
  giveOutFullVersion: () => {},
  renderDataObjectName: () => {},
  sortUsersListByDateOfCreation: () => {},
  updateDataLoading: false,
  directionRenderStr: () => {},
  directionStr: '',
  deleteUser: () => {},
};

export default UserView;
